import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-highlight-all',
  templateUrl: './pdf-find-highlight-all.component.html',
  styleUrls: ['./pdf-find-highlight-all.component.css'],
})
export class PdfFindHighlightAllComponent {}
